import Button from "../../../components/Button";
import ProgressBar from "../../../components/ProgressBar";
import AddIcon from "/public/images/icons/add.svg?react";
import { useNavigate } from "react-router-dom";
import { useDrawerContext } from "../../../context/drawerContext";
import CloseIcon from "/public/images/icons/close.svg?react";
import TextInput from "../../../components/TextInput";
import { useEffect, useState } from "react";
import MedicalCard from "../../../components/MedicalCard";
import PropTypes from "prop-types";

export default function Step3({ band, profile, medicalHistory, allergies, medications }) {
  const navigate = useNavigate();
  const { setOpen, setDrawerContent } = useDrawerContext();
  const [updatedMedicalHistory, setUpdatedMedicalHistory] = useState(localStorage.getItem("activeBandStep3") ? JSON.parse(localStorage.getItem("activeBandStep3")) : medicalHistory ? medicalHistory : []);
  const [deletedMedicalHistory, setDeletedMedicalHistory] = useState(localStorage.getItem("activeBandStep3Delete") ? JSON.parse(localStorage.getItem("activeBandStep3Delete")) : []);

  const openMedicalDrawer = () => {
    setOpen(true);
    setDrawerContent(
      <div className="w-full">
        <div className="flex items-center justify-between w-full">
          <br />
          <h2 className="leading-5 tracking-widest uppercase text-[12px]">
            Medical History
          </h2>
          <CloseIcon className='cursor-pointer' onClick={() => setOpen(false)} />
        </div>
        <div className="mt-6 flex flex-col justify-stretch">
          <h3 className="text-[24px]">Enter your condition name</h3>
          <p className="text-sportsDarkGrey mb-[26px]">
            You can update your medical history anytime from your profile page.
          </p>
          <form onSubmit={addMedicalHistory} className="flex flex-col gap-6">
            <TextInput label={"Condition Name"} name="conditionName" />
            <TextInput
              label="Additional Information"
              name="additionalInformation"
            />
            <Button submit className="!text-[#101820]">
              Confirm & Continue
            </Button>
          </form>
        </div>
      </div>
    );
  };

  const openEditDrawer = (index) => {
    setOpen(true);
    setDrawerContent(
      <div className="w-full">
        <div className="flex items-center justify-between w-full">
          <br />
          <h2 className="leading-5 tracking-widest uppercase text-[12px]">
            Medical History
          </h2>
          <CloseIcon className='cursor-pointer' onClick={() => setOpen(false)} />
        </div>
        <div className="mt-6 flex flex-col justify-stretch">
          <h3 className="text-[24px]">Edit your medical condition</h3>
          <p className="text-sportsDarkGrey mb-[26px]">
            You can update your medical history anytime from your profile page.
          </p>
          <form
            onSubmit={(e) => editMedicalHistory(e, index)}
            className="flex flex-col gap-6"
          >
            <TextInput
              key={"editCondition" + index}
              defaultValue={updatedMedicalHistory[index].name || updatedMedicalHistory[index].ConditionName}
              label={"Condition Name"}
              name="conditionName"
            />
            <TextInput
              key={"editAdditional" + index}
              defaultValue={updatedMedicalHistory[index].additionalInformation || updatedMedicalHistory[index].Notes}
              label="Additional Information"
              name="additionalInformation"
            />
            <TextInput
              type="hidden"
              key={"editDateAdded" + index}
              defaultValue={updatedMedicalHistory[index].dateAdded || updatedMedicalHistory[index].DateAdded}
              name="dateAdded"
            />
            <Button submit className="!text-[#101820]">
              Confirm & Continue
            </Button>
          </form>
        </div>
      </div>
    );
  };

  const addMedicalHistory = (event) => {
    event.preventDefault();
    const newDetails = new FormData(event.currentTarget);

    const conditionName = newDetails.get("conditionName")?.trim();
    const additionalInformation = newDetails.get("additionalInformation")?.trim();

    if (!conditionName) {
      return;
    }

    const newMedicalDataArray = [];

    newMedicalDataArray.push({
      name: conditionName,
      additionalInformation: additionalInformation,
      dateAdded: new Date(),
      ongoing: false,
    });

    setUpdatedMedicalHistory([...updatedMedicalHistory, ...newMedicalDataArray]);
    setOpen(false);
    setDrawerContent(<div></div>);
  };

  const editMedicalHistory = (event, index) => {
    event.preventDefault();

    const newMedicalHistory = updatedMedicalHistory.map((item, i) => {
      if (i === index) {
        item.name = event.currentTarget.conditionName.value;
        item.additionalInformation = event.currentTarget.additionalInformation.value;
        item.dateAdded = event.currentTarget.dateAdded.value;
      }
      return item;
    });
    setUpdatedMedicalHistory(newMedicalHistory);
    setOpen(false);
    setDrawerContent(<div></div>);
  };

  const removeMedicalHistory = (e, index) => {
    e.preventDefault(); // Prevent form submission

    setUpdatedMedicalHistory((prevHistory) => {
      const history = prevHistory[index];

      if (history.MedicalHistoryId) {
        setDeletedMedicalHistory((prevDeleted) => {
          // Check if the item already exists in deletedMedicalHistory to avoid adding it twice
          if (!prevDeleted.some(item => item.MedicalHistoryId === history.MedicalHistoryId)) {
            return [...prevDeleted, history];
          }
          return prevDeleted;
        });
      }

      return prevHistory.filter((_, i) => i !== index);
    });
  };

  const checkOngoing = (index) => {
    const newMedicalHistory = updatedMedicalHistory.map((item, i) => {
      if (i === index) {
        item.ongoing = !item.ongoing;
      }
      return item;
    });
    setUpdatedMedicalHistory(newMedicalHistory);
  };

  const validateStep3 = () => {
    localStorage.setItem("activeBandStep3", JSON.stringify(updatedMedicalHistory));
    localStorage.setItem("activeBandStep3Delete", JSON.stringify(deletedMedicalHistory));

    navigate("/add-band/4", { state: { 
      band: band, 
      profile: profile,
      allergies: allergies, 
      medications: medications
    } })
  }

  return (
    <div className="w-full min-h-svh flex flex-col justify-stretch mb-[50px] bg-[#F8F8F8]">
      <div className="p-[24px] flex flex-col gap-6 bg-white">
        <ProgressBar step={3} />
        <span className="tracking-[0.25em] text-[12px] uppercase font-semibold">
          Step 3
        </span>
        <h2>Please let us know your medical history</h2>
        <p>
          This information will be visible to venue staff and the public when
          your band is unlocked.
        </p>
      </div>
      {updatedMedicalHistory.length > 0 && (
        <div className={`bg-sportsLightGrey border-[#E3E3E3] border-t-[1px] p-[24px] flex justify-center flex-col gap-6 ${updatedMedicalHistory.length <= 1 ?'pb-[250px]' : 'pb-[200px]'}`}>
          {updatedMedicalHistory.map((item, index) => (
            <MedicalCard
              editFunc={() => openEditDrawer(index)}
              checkedFunc={() => checkOngoing(index)}
              removeFunc={(e) => removeMedicalHistory(e, index)}
              key={index}
              medication={item}
            />
          ))}
        </div>
      )}
      <div className="border-dashed border-t border-[#E3E3E3]" />

      <div className="fixed bottom-[60px] left-1/2 transform -translate-x-1/2 w-full max-w-[430px] border-t border-l border-r rounded-t-[32px] border-[#E3E3E3] bg-white p-[24px] flex flex-col justify-stretch gap-4">
        <Button className="font-semibold" onClick={openMedicalDrawer} variant="tertiary">
          <AddIcon className="w-[15px]" />
          {!updatedMedicalHistory.length > 0 ? 'Add Medical History' : 'Add Another'}
        </Button>
        <Button onClick={validateStep3}>
          {updatedMedicalHistory.length > 0 ? "Confirm & Continue" : "Continue Without Medical History"}
        </Button>
      </div>
    </div>
  );
}

Step3.propTypes = {
  band: PropTypes.object,
};